<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Rating from '$lib/PageSections/Reviews/Rating.svelte';
	import reviewsJSON from '$lib/PageSections/Reviews/reviews.json';

	let { product, title: titleProp = 'RECOMMENDED FOR YOU' } = $props();
	let { title, price, thumbnail, summary, noise, href } = product;

	let rating = reviewsJSON?.stats?.company?.average_rating;
</script>

<div
	class="bg-indow-grey-medium mx-auto w-full max-w-3xl rounded-none p-5 shadow-md sm:mb-8 md:rounded-xl md:p-8"
>
	<h3 class="text-indow-white mb-6 text-3xl">{titleProp}</h3>

	<div class="mb-8 flex flex-col gap-6 sm:flex-row">
		<div>
			<Image src={thumbnail} class="w-60 rounded sm:w-full " />
		</div>
		<div>
			<p class="text-indow-white mb-2 text-left text-2xl font-medium uppercase">
				{title}
			</p>
			<div class="mb-2 inline-block">
				<Rating stars="5" {rating} hideMetaData starWidth="1.35rem" />
			</div>
			<p class="text-indow-white text-left text-lg font-thin italic">
				Starting at ${price}/sf
			</p>
			<p class="text-indow-white text-left">{summary}</p>
			<div class="block sm:inline-block">
				<Button {href}>SHOP NOW</Button>
			</div>
		</div>
	</div>

	<h3
		class="bg-indow-white border-indow-white text-indow-grey-dark mb-0 rounded-t-xl border-2 px-6 pt-2 pb-1 text-lg font-bold sm:text-xl"
	>
		Performance Highlights
	</h3>

	<div
		class="bg-indow-grey-medium border-indow-white rounded-b-xl border-3 p-3 sm:p-6"
	>
		<ul
			class="flex w-full list-none flex-wrap justify-evenly gap-3 gap-y-6 md:gap-6"
		>
			<li class="flex flex-col-reverse gap-3">
				<h4 class="text-indow-white mb-0 pt-0 font-medium">
					ENERGY<br />SAVINGS
				</h4>
				<p
					class="bg-indow-white text-indow-grey-dark rounded-xl p-3 text-center sm:p-5"
				>
					<span class="text-sm font-medium">AVERAGE</span><br />
					<span class="text-3xl font-bold sm:text-4xl">20%</span>
				</p>
			</li>
			<li class="flex flex-col-reverse gap-3">
				<h4 class="text-indow-white mb-0 pt-0 font-medium">
					NOISE<br />REDUCTION
				</h4>
				<p
					class="bg-indow-white text-indow-grey-dark rounded-xl p-3 text-center sm:p-5"
				>
					<span class="text-sm font-medium">UP TO</span><br />
					<span class="text-3xl font-bold sm:text-4xl">{noise}%</span>
				</p>
			</li>
			<li class="flex flex-col-reverse gap-3">
				<h4 class="text-indow-white mb-0 pt-0 font-medium">
					PERFECT <br />FIT RATE
				</h4>
				<p
					class="bg-indow-white text-indow-grey-dark rounded-xl p-3 text-center sm:p-5"
				>
					<span class="text-sm font-medium">OVER</span><br />
					<span class="text-3xl font-bold sm:text-4xl">99%</span>
				</p>
			</li>
		</ul>
	</div>
</div>
